import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1742e967"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-top":"4px"}
}, "建议尺寸: 800 × 1120 px (5:7 竖图)", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "用户回收卡牌时获得的金额", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "数字越小越靠前", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.card,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "所属系列",
          prop: "card_series_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.card.card_series_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.card.card_series_id) = $event)),
              placeholder: "请选择系列",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardSeriesOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "卡牌名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.card.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.card.name) = $event)),
              placeholder: "请输入卡牌名称",
              maxlength: "100",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "稀有度",
          prop: "card_rarity_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.card.card_rarity_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.card.card_rarity_id) = $event)),
              placeholder: "请选择稀有度"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rarityOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "语系",
          prop: "card_language_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.card.card_language_id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.card.card_language_id) = $event)),
              placeholder: "请选择语系",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "版本号",
          prop: "card_version_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.card.card_version_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.card.card_version_id) = $event)),
              placeholder: "请选择版本",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "卡牌图片",
          prop: "image"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "",
              "auto-upload": false,
              "show-file-list": false,
              "on-change": _ctx.onImageChange
            }, {
              default: _withCtx(() => [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl,
                      class: "avatar"
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["on-change"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "描述",
          prop: "description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.card.description,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.card.description) = $event)),
              type: "textarea",
              rows: 3,
              placeholder: "请输入卡牌描述",
              maxlength: "500",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "回收价格",
          prop: "recycle_price"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.card.recycle_price,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.card.recycle_price) = $event)),
              min: 0,
              precision: 2,
              step: 1
            }, null, 8, ["modelValue"]),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sort"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.card.sort,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.card.sort) = $event)),
              min: 0,
              max: 9999
            }, null, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "enabled"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.card.enabled,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.card.enabled) = $event)),
              "active-text": "启用",
              "inactive-text": "停用"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}